import { LinearProgress, withStyles } from '@material-ui/core'
import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import withErrorCatcher from '../../../components/Common/withErrorCatcher'
import { useTranslation } from 'react-i18next'
import { styled } from '@material-ui/styles'

const styles = theme => ({
    container: {
        position: 'relative',
        zIndex: 1,
        marginTop: '10vh',
        marginRight: 'auto',
        marginLeft: "auto",
        display: 'flex',
        flexDirection: 'column',
        width: 'fit-content',
        alignItems: 'center',
    },
    title: {
        color: "#18181B",
        fontFamily: "Rubik",
        fontSize: 24,
        fontStyle: "normal",
        fontWeight: 600,
        lineHeight: "32px"
    },
    subtitle: {
        color: "#6B6F7A",
        fontFamily: "Rubik",
        fontSize: 14,
        fontStyle: "normal",
        fontWeight: 400,
        lineHeight: "20px"
    },
    btns: {
        marginTop: '3vh',
        display: 'flex',
        marginBottom: '6vh',
        alignItems: 'center'
    },
    btn: {
        marginLeft: 16,
        cursor: 'pointer',
        display: "flex",
        background: '#6366F1',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: "space-between",
        padding: '6px 30px',
        borderRadius: 6,
        border: '1px solid transparent',
        height: 20,
        width: 'fit-content'
    },
    btnWhite: {
        border: '1px solid #B7B8BD33',
        cursor: 'pointer',
        display: "flex",
        background: '#fff',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: "space-between",
        padding: '6px 30px',
        borderRadius: 6,
        height: 20,
        width: 'fit-content'
    },
    btnText: {
        color: "#fff",
        fontFamily: "Rubik",
        fontSize: 14,
        fontStyle: "normal",
        fontWeight: 500,
        lineHeight: "20px"
    },
    btnTextWhite: {
        color: "#6B6F7A",
        fontFamily: "Rubik",
        fontSize: 14,
        fontStyle: "normal",
        fontWeight: 500,
        lineHeight: "20px"
    },
    disabledBtn: {
        pointerEvents: 'none',
        background: '#B7B8BD'
    },
    content: {
        marginTop: '10vh',
        display: 'flex',
        width: '42vw',
        padding: "var(--16, 16px) 16px",
        flexDirection: 'column',
        justifyContent: "center",
        alignItems: "flex-start",
        borderRadius: 8,
    },
    label: {
        marginBottom: 8,
        marginTop: 24,
        marginRight: 'auto',
        marginLeft: 'auto',
        color: "#18181B",
        fontFamily: "Rubik",
        fontSize: 14,
        fontStyle: "normal",
        fontWeight: 500,
        lineHeight: "20px"
    },
    input: {
        color: '#21212d',
        width: '-webkit-fill-available',
        resize: 'none',
        padding: 0,
        outline: 0,
        fontSize: 14,
        fontStyle: 'normal',
        fontWeight: 400,
        fontFamily: "Rubik",
        lineHeight: "16px",
        paddingLeft: 8,
        paddingRight: 8,
        backgroundColor: "transparent",
        borderRadius: 8,
        border: '1px solid #B7B8BD33',
        height: 32,
        fontFeatureSettings: "'clig' off, 'liga' off",
        "&::placeholder": {
            color: '#B7B8BD',
        },
    },
    progressPrimary: {
        background: "var(--bg-accent-alt-DEFAULT, rgba(129, 140, 248, 0.10))",
    },
    progressAccent: {
        backgroundColor: '#818CF8',
    }
})

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 10,
    marginRight: 'auto',
    marginLeft: 'auto',
    width: '22vw',
    marginTop: '4vh',
    borderRadius: 2,
  }));


const _Step4 = (props) => {
    const { classes, orgName, userName, templateName } = props
    const [t] = useTranslation("admin")
    const [progress, setProgress] = React.useState(0);

    React.useEffect(() => {
      const timer = setInterval(() => {
        setProgress((oldProgress) => {
          if (oldProgress === 100) {
            return 0;
          }
          const diff = Math.random() * 10;
          return Math.min(oldProgress + diff, 100);
        });
      }, 500);
  
      return () => {
        clearInterval(timer);
      };
    }, []);

    return <div className={classes.container}>
        <div className={classes.title}>{t("We Are Getting Things Ready")}</div>
        <div className={classes.subtitle}>{t("{{userName}}, we are setting up Tuqqi to {{orgName}}. You chose to start with {{templateName}}, it will be ready soon", {templateName, userName, orgName})}</div>
        <div className={classes.content}>
            <BorderLinearProgress classes={{colorPrimary: classes.progressPrimary, barColorPrimary: classes.progressAccent}} value={progress} variant="determinate" />
            <div className={classes.label}>{t("This may take up to 30 seconds.")}</div>
        </div>
    </div>
}

const mapStateToProps = (state, ownProps) => ({

})

const mapDispatchToProps = (dispatch) => ({ dispatch })


export const Step4 = compose(
    withStyles(styles, { withTheme: true }),   
    connect(mapStateToProps, mapDispatchToProps),
    withErrorCatcher("Failed loading user, Please Contact Tuqqi Support")
)(_Step4)